<template>
  <div>
    <sk-card
      :title="title"
      :linkAddress="$t('COUPON_DOC')"
      :linkMessage="$t('代金券帮助文档')"
    ></sk-card>
    <div class="jc-page-content">
      <div class="coupon-tab">
        <jc-tabs v-model="tabDefaultChoice" @tab-click="activeOn">
          <jc-tab-pane :label="$t('可使用')" :name="0"></jc-tab-pane>
          <jc-tab-pane :label="$t('已用完')" :name="1"></jc-tab-pane>
          <jc-tab-pane :label="$t('已过期')" :name="2"></jc-tab-pane>
        </jc-tabs>
        <jc-button
          type="primary"
          class="button_intab"
          @click="to_couponManage"
          v-if="haveManagePower"
          >{{ $t('券额管理') }}</jc-button
        >
        <jc-button type="text" class="tab_right" @click="view_activeCoupon">{{
          $t('激活代金券')
        }}</jc-button>
      </div>
      <div class="buildCon">
        <jc-table
          :empty-text="$t('暂无未使用代金券')"
          class="no-border con-table0"
          :data="tableData"
        >
          <jc-table-column
            prop="number"
            :label="$t('代金券编码')"
            :min-width="'100'"
          ></jc-table-column>
          <jc-table-column :label="$t('适用产品')" width="100px">
            <template slot-scope="scope">
              <jc-tooltip placement="right">
                <div slot="content">{{ scope.row.appName }}</div>
                <jc-button type="text" class="container">{{
                  scope.row.appName
                }}</jc-button>
              </jc-tooltip>
            </template>
          </jc-table-column>
          <jc-table-column
            :label="$t('计费类型')"
            :min-width="'80'"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">{{
              billingTypeTurn(scope.row.billingTypeIndex)
            }}</template>
          </jc-table-column>
          <jc-table-column
            :label="$t('支持地域')"
            :min-width="'80'"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">{{
              scope.row.region | filterRegion
            }}</template>
          </jc-table-column>
          <jc-table-column :label="$t('面额_元_')" :min-width="'120'">
            <template slot-scope="scope">{{
              scope.row.fee | formatMoney
            }}</template>
          </jc-table-column>
          <template>
            <jc-table-column :label="$t('余额_元_')" :min-width="'120'">
              <template slot-scope="scope">{{
                scope.row.balance | formatMoney
              }}</template>
            </jc-table-column>
          </template>

          <jc-table-column :label="$t('有效日期')" width="165">
            <template slot-scope="scope">
              {{ scope.row.validStartTime | IETimeFormat }}{{ $t('至') }}
              <br />
              {{ scope.row.validEndTime | IETimeFormat }}
            </template>
          </jc-table-column>
          <jc-table-column
            prop="statusName"
            :label="$t('状态')"
            :min-width="'70'"
          ></jc-table-column>
          <jc-table-column
            v-if="tabDefaultChoice == null"
            :label="$t('购买方式')"
            prop="purchaseTypName"
            :min-width="'120'"
          ></jc-table-column>
          <jc-table-column
            prop="payType"
            :label="$t('类型')"
            :min-width="'70'"
          ></jc-table-column>
          <jc-table-column
            prop="purchaseType"
            :label="$t('操作')"
            :min-width="'130'"
          >
            <template slot-scope="scope">
              <a
                :href="scope.row.skipUrl && scope.row.skipUrl.replace(/ /g, '')"
                class="blueLink"
                v-if="
                  tabDefaultChoice == 0 &&
                  scope.row.skipUrl &&
                  !skipUrls.includes(scope.row.skipUrl.replace(/ /g, ''))
                "
                target="_blank"
                >{{ $t('立即使用') }}</a
              >
              <router-link
                class="blueLink"
                :to="{
                  path: '/cost/coupon-detail',
                  query: { id: scope.row.number, type: tabDefaultChoice },
                }"
                >{{ $t('查询明细') }}</router-link
              >
            </template>
          </jc-table-column>
        </jc-table>
        <div class="botDiv">
          <template>
            <div class="mr8">
              <jc-pagination
                align="right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></jc-pagination>
            </div>
          </template>
        </div>
      </div>
    </div>
    <jc-dialog
      :visible.sync="viewActiveCoupon"
      size="tiny"
      :title="$t('激活代金券')"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div class="popup activeLayer" v-loading="activeLoad" style="padding: 0">
        <ul class="listItem">
          <li>
            <p class="tit">
              <span>{{ $t('代金券兑换码_') }}</span>
            </p>
            <div class="con">
              <input
                type="text"
                class="inputMode book-w200"
                :placeholder="$t('请输入兑换券码')"
                v-model="couponCode"
                @blur="checkValid('couponCode')"
              />
              <p class="new-tips">
                &nbsp;
                <span class="red" v-if="couponCodeErr">{{
                  $t('券码为空或长度错误')
                }}</span>
              </p>
            </div>
          </li>
          <li>
            <p class="tit">
              <span>{{ $t('验证码_') }}</span>
            </p>
            <div class="con">
              <input
                type="text"
                class="inputMode book-w130"
                :placeholder="$t('请输入验证码')"
                v-model.trim="verifyCode"
                maxlength="4"
                @blur="checkValid('verifyCode')"
              />
              <img :src="verifyUrl" width="70" height="30" />
              <a
                href="#"
                class="blueLink"
                @click.prevent="getVerifyCode"
                v-loading="codeload"
                >{{ $t('看不清点击刷新') }}</a
              >
              <p class="new-tips">
                &nbsp;
                <span class="red" v-if="vertifyCodeErr">{{
                  $t('验证码输入有误')
                }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <p slot="footer" class="dialog-footer">
        <jc-button @click="viewActiveCoupon = false">{{
          $t('取消')
        }}</jc-button>
        <jc-button
          type="primary"
          @click="activeCoupnEvt"
          :disabled="activeLoad"
          >{{ $t('激活') }}</jc-button
        >
      </p>
    </jc-dialog>
  </div>
</template>

<script>
import getTranslation from '@/i18n/getTranslation'

import titleBar from '@/components/titleBar'
import {
  getCouponUseMsg,
  checkPermission,
  getMobileCodeInfo,
  activeCoupon,
  getConsoleVersion
} from '@/api/coupon-api.js'
import { BILLING_TYPE_MAP } from '@/utils/constant.js'
export default {
  name: 'coupon',
  data() {
    return {
      title: getTranslation('代金券管理'),
      type: '',
      tabDefaultChoice: 0,
      vlock: true,
      pageSize: 10,
      total: 10,
      currentPage: 1,
      tableData: [],
      haveManagePower: false,
      viewActiveCoupon: false,
      couponCode: '',
      verifyCode: '',
      verifyUrl: `${process.env.BASE_URL}img/code.jpeg`,
      couponCodeErr: false,
      vertifyCodeErr: false,
      uid: '',
      codeload: false,
      activeLoad: false,
      skipUrls: ['null', 'https://', 'http://']
    }
  },
  components: {
    titleBar
  },
  watch: {
    couponCode() {
      this.couponCodeErr = false
    },
    verifyCode() {
      this.vertifyCodeErr = false
    },
    viewActiveCoupon() {
      this.couponCode = ''
      this.verifyCode = ''
      this.couponCodeErr = false
      this.vertifyCodeErr = false
    }
  },
  methods: {
    billingTypeTurn(billType) {
      // 处理计费类型
      let bT = billType
      let length = BILLING_TYPE_MAP.length - 1
      let billingTypeInfo = ''
      for (let i = length; i >= 0; i--) {
        let type = BILLING_TYPE_MAP[i].value && bT - BILLING_TYPE_MAP[i].value
        if (type >= 0) {
          bT = type
          billingTypeInfo += BILLING_TYPE_MAP[i].label + ','
        }
      }
      billingTypeInfo = billingTypeInfo.substring(0, billingTypeInfo.length - 1)
      return billingTypeInfo
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadData(this.currentPage, this.tabDefaultChoice, this.pageSize)

      var _par = Object.assign(
        {},
        {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          type: this.$route.query.type || 0 //默认0
        }
      )
      this.$router.push({ path: 'coupon', query: _par })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      let inputPage = document.getElementsByClassName(
        'jc-pagination__editor'
      )[0],
        vm = this
      inputPage.value = vm.currentPage
      inputPage.onblur = function (e) {
        let ele = e.target || e.srcElement
        ele.value = vm.currentPage
      }
      var _par = Object.assign(
        {},
        {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          type: this.$route.query.type || 0 //默认0
        }
      )
      this.$router.push({ path: 'coupon', query: _par })
      this.loadData(this.currentPage, this.tabDefaultChoice, this.pageSize)
    },
    activeOn() {
      const ind = this.tabDefaultChoice
      this.loadData(1, ind, this.pageSize)
      this.$router.push('/cost/coupon?type=' + ind)
    },
    async loadData(num, ind, pageSize) {
      try {
        let res = await getCouponUseMsg(
          {
            currentPage: num || 1,
            status: ind || 0, // 默认未使用
            pageSize: pageSize || 10
          },
          {
            target: '.innerCon'
          }
        )
        if (res.body.result) {
          this.tableData = (res.body.result && res.body.result.data) || []
          this.tableData.forEach((element) => {
            element.statusName = getTranslation(element.statusName)
            let arr = element.appName.split(',')
            let value = ''
            arr.forEach((e, index) => {
              if (e !== '') {
                value += `${getTranslation(e)}${index === arr.length - 1 ? '' : ','
                  }`
              }
              element.appName = value
            })
            // if (element.appName.indexOf('<br>') >= 0)
            //   element.appName = element.appName.split('<br>')
            // if (element.appName.indexOf('</br>') >= 0)
            //   element.appName = element.appName.split('</br>')
            // if (typeof element.appName === 'string') {
            //   element.appName = getTranslation(element.appName)
            // } else {
            //   element.appName.forEach((_name, index) => {
            //     element.appName[index] = getTranslation(_name)
            //   })
            //   element.appName = element.appName.join('<br>')
            // }
          })
          this.total =
            (res.body.result.pageInfo &&
              res.body.result.pageInfo.totalRecord) ||
            0
        }
        // else {
        //   this.$notify(res.body.msg || res.body.message)
        // }
      } catch (err) {
        console.log(err)
      }
    },
    async getManagePower() {
      let _result = await checkPermission()
      if (_result && _result.body && _result.body.result) {
        _result = _result.body.result
        this.haveManagePower =
          _result.permission == 0 || _result.permission == 2 ? false : true
      }
    },
    async to_couponManage() {
      try {
        let {
          body: {
            result: { data }
          }
        } = await getConsoleVersion()
        if (data === 1) {
          this.$router.push('/cost/quota-coupon')
        } else {
          this.$router.push('/cost/coupon-limitation')
        }
      } catch (e) {
        console.log(e)
        this.$router.push('/cost/coupon-limitation')
      }
    },
    view_activeCoupon() {
      this.viewActiveCoupon = !this.viewActiveCoupon
      this.getVerifyCode()
    },
    async getVerifyCode() {
      this.codeload = true
      this.verifyCode = ''

      let _result = await getMobileCodeInfo({
        source: 'couponActive'
      })
      this.codeload = false
      if (_result && _result.body) {
        _result = _result.body
        if (_result.code == 0) {
          this.uid = _result.result.uid
          this.verifyUrl =
            '/v1/coupons/imgcode?uid=' +
            _result.result.uid +
            '&signature=' +
            _result.result.sign +
            '&source=' +
            _result.result.source +
            '&time=' +
            Math.random()
        } else {
          this.codeload = false
          this.$notify({
            message: getTranslation('获取验证码失败'),
            type: 'error'
          })
        }
      }
    },
    checkValid(type) {
      if (type == 'couponCode') {
        this.couponCodeErr =
          this.couponCode === '' ||
            this.couponCode.length < 6 ||
            this.couponCode.length > 10
            ? true
            : false
      }
      if (type == 'verifyCode') {
        this.vertifyCodeErr =
          this.verifyCode === '' || this.verifyCode.length !== 4 ? true : false
      }
    },
    async activeCoupnEvt() {
      this.couponCodeErr =
        this.couponCode === '' ||
          this.couponCode.length < 6 ||
          this.couponCode.length > 10
          ? true
          : false
      this.vertifyCodeErr =
        this.verifyCode === '' || this.verifyCode.length !== 4 ? true : false
      if (this.couponCodeErr || this.vertifyCodeErr) return
      this.activeLoad = true
      try {
        let _result = await activeCoupon({
          couponNumber: this.couponCode,
          verifyCode: this.verifyCode,
          uid: this.uid
        })
        this.getVerifyCode()
        this.activeLoad = false
        if (_result && _result.body && _result.body.result) {
          _result = _result.body.result
          if (_result.success === true) {
            this.viewActiveCoupon = false
            this.$notify({
              message: getTranslation('代金券激活成功'),
              type: 'success'
            })
            this.tabDefaultChoice = 0
          } else {
            this.$notify({
              message: _result.message,
              type: 'error'
            })
          }
        }
      } catch (err) {
        this.getVerifyCode()
        this.activeLoad = false
        // this.$notify({
        //   message: getTranslation('代金券激活失败'),
        //   type: 'error'
        // })
      }
    }
  },
  created: function () {
    this.getManagePower()
    if (this.$route.query.type) {
      if (this.$route.query.currentPage) {
        let { currentPage, pageSize, type } = this.$route.query
        this.currentPage = Number.parseInt(currentPage) || 1
        this.pageSize = Number.parseInt(pageSize) || 10
        this.type = Number.parseInt(type) || 0
        //带参数请求
        this.tabDefaultChoice = Number(type)
        this.loadData(currentPage || 1, type || 0, pageSize || 10)
      } else {
        this.tabDefaultChoice = Number(this.$route.query.type) || 0
        this.loadData(1, 0, 10)
      }
    } else {
      this.loadData(1, 0, 10)
    }
  }
}
</script>

<style scoped="true">
.coupon-tab {
  position: relative;
  background-color: #fff;
}
.el-table.table-no-border {
  border-width: 0;
}
.el-table.no-border {
  border: 0;
}
.buildCon .botDiv {
  border-top: none;
}
.button_intab {
  position: absolute;
  top: 0;
  left: 260px;
  margin: 4px 0;
}
.tab_right {
  position: absolute;
  top: 0;
  right: 40px;
  margin: 4px 0;
}
.tab_right .tab-link {
  margin: 0 16px 0 0;
}

.activeLayer {
  font-size: 12px;
}
.container {
  overflow: hidden;
  width: 60px; /* 父元素宽度为 100px */
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="css">
.jc-tooltip__popper {
  max-width: 25%;
}
</style>
